import React, { useEffect, useState } from 'react'
import { getDateNow , convertDateToString } from '../utils'

export const ContextOverTime = React.createContext<any>({})


export default function ContextOverTimeModels(props: any) {
    const [jsonParmsOverTime, setJsonParmsOverTime] = useState<any>({ 'from': getDateNow(), 'to': getDateNow() , 'page':1 , 'user':[] })
    const [activeFilterOverTime, setActiveFilterOverTime] = useState<any>({
        'activePeriod': -1 ,
        'qr_code_id':-1 ,
        'status':-1 ,
        'type':-1 ,
        'user':[],
        'startCalender':new Date() ,
        'endCalender':new Date(),
    })




    return (
        <ContextOverTime.Provider value={{
            activeFilterOverTime,
            setActiveFilterOverTime ,
            jsonParmsOverTime ,
            setJsonParmsOverTime
        }}>
            {props.children}
        </ContextOverTime.Provider>
    )
}